import { TagType } from 'src/graphql';
import { getOrderedColor } from 'src/utils';

interface GroupedOptionsType {
  label: string;
  color: string;
  count: number;
  options: { value: string; label: string }[];
}

export const getGroupedTags = (allTags: TagType[], selectedTags: TagType[]) => {
  let groupedOptions: { [key: string]: GroupedOptionsType } = {};
  const selectedOptions = selectedTags.map((tag) => ({
    value: tag.id,
    label: tag.name,
  }));

  for (const item of allTags ?? []) {
    const { id, name, tagType } = item;

    if (tagType?.name) {
      const key = tagType.name;

      if (!groupedOptions[key]) {
        groupedOptions[key] = {
          label: tagType.name,
          color: getOrderedColor(tagType.colorId),
          count: 0,
          options: [{ value: id, label: name }],
        };
      } else {
        groupedOptions[key].options.push({ value: id, label: name });
      }

      const tagIsSelected = selectedTags.some((tag) => tag.id === id);
      if (tagIsSelected) {
        groupedOptions[key].count += 1;
      }
    }
  }

  return { groupedOptions: Object.values(groupedOptions), selectedOptions };
};
